import React from "react";
import imageFile from "./../../include/images/Icons/User.svg";
const AvtarImage = () => {
  return <img src={imageFile} />;
};

export default AvtarImage;
